<template>
  <div class="sidebarElementGroup">
    <div class="sidebarElementGroup--name">{{ group.groupName ?? "Untitled group" }}</div>
    <SidebarElement v-for="(element, i) in group.groupElements" :key="i" :element="element" />
    <SidebarElementCreator :groupID="group._id" />
  </div>
</template>

<script>
import SidebarElementCreator from "./SidebarElementCreator.vue";

export default {
  name: "SidebarElementGroup", // Named exceptionally because needed for recursive component
  components: {
    SidebarElement: () => import("./SidebarElement.vue"), // for recursion: https://stackoverflow.com/a/58875919/8010396
    SidebarElementCreator,
  },
  props: {
    group: Object,
  },
};
</script>

<style>
.sidebarElementGroup {
  width: 100%;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px auto;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255 / 42%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
}
.sidebarElementGroup--name {
  padding: 5px;
  font-size: 16px;
  color: #424242;
  margin-bottom: 10px;
}
</style>
